var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyCart = function SvgEmptyCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "#004152",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.735 14.018a1 1 0 0 1 .876-.518h6.859c.75 0 1.41-.41 1.75-1.03l3.38-6.14a.99.99 0 0 0 .113-.629A1 1 0 0 0 21 4H6c-.033 0-.066.002-.098.005l-.17-.36A2 2 0 0 0 3.924 2.5H2.92a1 1 0 0 0 0 2h.225c.473 0 .904.273 1.107.7l2.828 5.963a2 2 0 0 1-.057 1.825L6.17 14.53c-.73 1.34.23 2.97 1.75 2.97h11a1 1 0 1 0 0-2H9.611a1 1 0 0 1-.876-1.482ZM7.92 18.5c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2ZM17.92 18.5c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2Z"
  })));
};
export default SvgEmptyCart;